import React from 'react';
import Head from 'next/head';
import type { AppProps } from 'next/app';
import Container from '../layouts/Container';
import '../styles/globals.css';
import '@zillow/constellation-fonts/zillow-legacy-fonts.css';
import { wrapper } from '../store/store';
import { Provider } from 'react-redux';

const MyApp = ({ Component, pageProps }: AppProps) => {
  const store = wrapper.useWrappedStore({});

  return (
    <>
      <Head>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, interactive-widget=resizes-content"
        />
        <meta name="mobile-web-app-capable" content="yes" />
        <meta name="full-screen" content="yes" />
        <meta name="browsermode" content="application" />
        <meta name="screen-orientation" content="portrait"></meta>
      </Head>
      <Provider store={store.store}>
        <Container>
          <Component {...pageProps} />
        </Container>
      </Provider>
    </>
  );
};

export default MyApp;
